// Dead email address prompt (backend flag `email_undeliverable`, set in
// SiteAPI::prepareCurrentUser()). Kept free of React/DOM imports so it can be unit tested.
// The "shown recently" state lives in a cookie that expires after a week, so the prompt
// comes back at most once a week.

export const EMAIL_UNDELIVERABLE_COOKIE = 'emailUndeliverablePrompt';

// Cookie lifetime in seconds (utils/cookie setCookie takes seconds): one week.
export const EMAIL_UNDELIVERABLE_PROMPT_INTERVAL_SECONDS = 7 * 24 * 60 * 60;

/**
 * @param {object} user current user object (BobTVUser or plain)
 * @return {boolean} true when the backend says the member's address cannot receive email
 */
export function isEmailUndeliverable(user) {
    return !!user && user.email_undeliverable === 1;
}

/**
 * @param {{get: function(string): (string|undefined)}} cookies e.g. {get: getCookie, set: setCookie} from utils/cookie
 * @return {boolean} true while the weekly cookie exists
 */
export function wasPromptShownRecently(cookies) {
    try {
        return !!cookies.get(EMAIL_UNDELIVERABLE_COOKIE);
    } catch (e) {
        return false;
    }
}

export function markPromptShown(cookies) {
    try {
        cookies.set(EMAIL_UNDELIVERABLE_COOKIE, '1', EMAIL_UNDELIVERABLE_PROMPT_INTERVAL_SECONDS, '/');
    } catch (e) {
        // ignore: worst case the prompt can be shown again after a reload
    }
}

/**
 * The prompt is shown at most once a week (until the cookie expires).
 */
export function shouldShowPrompt(user, cookies) {
    return isEmailUndeliverable(user) && !wasPromptShownRecently(cookies);
}



// WEBPACK FOOTER //
// ./src/utils/emailUndeliverable.js